import { ApiMessage, ChatMessage } from '~/features/chatbot/types/chatbot.types';
import { RECOVERY_MESSAGE } from '~/features/chatbot/constants/messages';

export const transformApiMessages = (
    sessionId: string,
    apiMessages: ApiMessage[]
): ChatMessage[] => {
    return apiMessages.map((msg, index) => ({
        id: `${sessionId}-msg-${index}`,
        sessionId,
        content: msg.content,
        role: msg.role,
        timestamp: msg.timestamp,
        isRecoveryMessage: msg.role === 'ASSISTANT' && msg.content === RECOVERY_MESSAGE,
    }));
};
